<template>
  <div>
  
    
    <b-row >
       
  <!----- SideBar All Design List ---->
   <div class="detailside">
     <sidebarAllDesignsComponent></sidebarAllDesignsComponent>
   </div>
  <!----- SideBar All Design List End ----> 
  
     <div class="design-container-details__main" style="width:50%">
        <div class="brand-card" >

          <div class="col-md-12" style="margin-top:10px;margin-bottom:10px;padding-left: 20px">
             <div class="col-md-12">Design Title:<strong> &nbsp;{{style_details.design_title}}</strong> </div>
              <div class="col-md-12">Style Name : &nbsp;{{style_details.style_name}} >> {{style_details.sub_cattitle}}</div>
              <div class="col-md-12">Created Date : {{style_details.created_date }} </div>
              <div class="col-md-12">Buyer Name : {{style_details.sendqname }} </div>
          </div>

<!-- Code For Tab -->
<div id="navbardetails" class="navbardesign">
  <navbarMenu></navbarMenu>
</div>
<div class="navbardesignsm">
  <navbarMenu></navbarMenu>
</div>
<br>
<b-col sm="12" class="text-right">
       <button id="button-1" v-b-tooltip.hover title="Select Vendor" type="button"  class="btn btn-default userbtn" @click="onlineuserfun()" style="color: #24a0ed;font-size: 14px;float:left;margin-bottom:10px">
              <i  class="fa fa-users" aria-hidden="true"></i></button>

</b-col>

         <b-row class="col-md-12 container-fluid" > 


                 

                    <div class="col-md-3 onlineuser" id="onlineuserdropdown">
                      <div class="card-header" id="heading_data">
                        <div class="input-group"><h6>Online Users</h6></div>
                       </div>
                     

                          <div class="card-body" id="contacts_body">
                               <input type="text" id="myInput" v-on:keyup="myFunction()" placeholder="Search for Vendors..." title="Type in a name" class="inputsearch"/>
                          <ul class="contacts">
                          <li class="active">
                            <!-- @click="messagedisplay(user.vendor_id)" -->
                            <div class="d-flex bd-highlight" id="select_user" v-for="data in vendor_list" @click="getvendormsg(data.vendor_id, data.vendor_name)">
                              <div class="col-md-1 img_cont"><span class="online_icon1 icon1"></span><img  src="../assets/images/user.jpeg" class="rounded-circle user_img1" >
                              </div>
                              <!-- <div class="col-md-1"></div> -->
                              <div class="col-md-3 vendorname" >{{data.vendor_name}}</div>
                            </div>
                          </li>
                          </ul>
                        </div>
                        <!-- <div class="card-footer msg-footer"></div> -->
                    </div>
                    <div class="col-md-9">
                      <div class="card chat" >
                          <div class="card-header msg_head" id="headingdata">
                            <div class="d-flex bd-highlight vendorhead" >
                              <div class="img_cont">
                                <img src="../assets/images/user.jpeg" class="rounded-circle user_img">
                                <span class="online_icon"></span>
                              </div>
                              <div class="col-md-3 headervendorname" ><b>{{selected_vendor_name}}</b></div>
                              <div class="col-md-4 refreshmsg" ><i class="fa fa-refresh " aria-hidden="true" @click="refreshmessage()"></i>
                              </div>
                             
                            </div>
                          </div>
                          <div class="card-body" id="chatbody" >
                            <div class="d-flex justify-content-start mb-4" style="float: right;">
                              <table class="msg_body">
                                <tbody v-if="returnmsg_data=='Successful'">
                                <tr v-for="date_msg in messagedata.message_json"  class="tr_class">
                                  <tr v-for="date in Object.keys(messagedata.message_json)" style="float: right !important;" ><b-col md="12" ><strong class="buyerdate">{{date}}</strong></b-col>
                                      <td><tr v-for="data1 in messagedata.message_json">
                                        <td ><tr v-for="msg in data1" v-if="msg.date==date" class="tr_class"><b-col md="12" >
                                          <td class="admin_msg" v-if="msg.message_by=='Buyer'" id="adminmsgid"><img  src="../assets/images/fcc.jpeg" class="rounded-circle user_img_msg" id="vendor" ><b>{{selected_buyer}}</b> <!-- &nbsp;( {{selected_usertype}}&nbsp;) &nbsp; --> <span v-if="msg.message_by=='Buyer'"  style="margin-top: 5px; float:right;">{{msg.time}}</span><br><h6>{{msg.message}}</h6>
                                          </td>
                                          <td class="vendor_msg_class" v-if="msg.message_by=='Vendor'" style="float: left !important;"><img  src="../assets/images/user.jpeg" class="rounded-circle user_img_msg" id="vendor" ><b>{{selected_vendor_name}}</b> &nbsp;<div v-if="msg.message_by=='Vendor'"  style="float: right;margin-top: 5px;">{{msg.time}}</div><br><h6>{{msg.message}}</h6>
                                          </td>
                                          <b-col md="12"></b-col>
                                        </b-col>
                                        <!-- <b-col md="12" ><div v-if="msg.message_by=='Buyer'"  class="admin_msg_time" >{{msg.time}}</div>
                                        <div v-if="msg.message_by=='Vendor'"  class="vendor_msg_time">{{msg.time}}</div></b-col> -->
                                      </tr>
                                    </td>
                                        
                                      </tr></td>

                                 </tr>
                               </tr>
                            
                                </tbody>

                                <!-- Else Part -->
                                <tbody  v-if="returnmsg_data==='Unsuccessful'">
                                <tr style="background-color: #f5f5f5" class="tr_class">
                                  <td><b-col md="12" ><div class="messagerecord">No Records Found</div></b-col></td>
                                </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                          

                          <div class="card-footer msg-footer">
                            <div class="input-group" > 
                              
                              <textarea id="txtName type_msg" v-model="txtInput"  class="form-control " placeholder="Type your message..."></textarea>
                              <div class="input-group-append">

                                <button type="submit" class="input-group-text send_btn  btn btn-primary" v-bind="txtInput" @click="onMessageSubmit()"><i class="fa fa-send-o"></i></button>
                              </div>
                            </div>
                          </div>
                        </div>
                    </div>
                  <!-- </b-row> -->

                <!-- </div> -->
                </b-row> 
               <!-- </div> -->
            </div>
        </div>




 </b-row>    



   </div>


 
</template>
<script src="/socket.io/socket.io.js"></script>
<script>

   import CONSTANTS from '@/utils/constants'
   import auth from '@/utils/auth'
   import Vue from 'vue'
   import Router from 'vue-router'
   import Utils from "@/utils";
   import sidebarAllDesignsComponent from './_sidebarAllDesignsComponent.vue'
   import navbarMenu from './_navbarMenu.vue'
   // import sidebarAllDesignsComponent from './_sidebarAllDesignsComponent.vue'
   // import navbarMenu from './_navbarMenu.vue'
   //var socket = io();
   const axios = require('axios')
   export default {
     name: 'Tabs',
     components: {
        sidebarAllDesignsComponent,
        navbarMenu
      },  

     data () {
       return {
        style_details: [],
        route_id: '',
        user_type: '',
        isBusy: false,
        result: [],
        file_tab_status: false,
        visible : true,
        list: [],
        customer: {},
        messagedata: [],
        selected_date: [],
        selectedId: 0,
        txtInput: '',
        totalRows: 0,
        vendor_list: [],
        selected_brand_id: 0,
        selected_vendor_id: 0,
        selected_vendor_name:'',
        returnmsg_data:'',
        selected_buyer: '',
        selected_usertype: '',
         scrolled:false,
        }  
     },
     created: function() {
      this.displayvendorlist();
      this.getdesigndetail();
      this.getvendorlist();
      this.route_id=this.$route.params.id;
       window.addEventListener('scroll', this.scroll);

      // var userData = localStorage.getItem('userData');
      // var userInfo = JSON.parse(userData);
      // this.user_type = userInfo[0].user_type;
      // this.displayvendorname();
      // this.getvendormsg();
    },
     destroyed () {
  // alert("innn");
  window.removeEventListener('scroll', this.scroll);
},

       methods: { 
        selectvendorname:function(){
          // alert("infun");
        },
        getvendorlist: function(){
          var userdata = localStorage.getItem('userData')
        var userInfo = JSON.parse(userdata)
        var recarr=[];

          // recarr=this.selectedVendor;
          const Obj={
               // brand_id: 621,
              // brand_id: userInfo[0].brand_assign,
              style_id: this.$route.params.id
          }
        //   style_id->143  
        // agentmaster   getvendorlist
        axios.post(`${CONSTANTS.API_URL}/getqutationdetails`,Obj)
          .then((result) => {
            // document.getElementById("overlay").style.display = "none";
            // this.vendor_msg = result.body.returnmsg;
            // this.agentmaster = result.body.returnvalue;
            this.vendor_list = result.data.returnvalue;
            console.log("UUUUUUUUUUUUUUUUUUUUU", this.vendor_list[0].vendor_name);
            // this.selected_vendor = this.vendor_list.returnvalue[0].vendor_name
        //     console.log("VVVVVVVVVVVVVVVVVVVVVV",this.selected_vendor);
        //      for(var i = 0; i < this.agentmaster.length; i++) {
        //       var vendoryagent2 = {
        //   id: this.agentmaster[i].vendor_id
        // }
        // this.vendor_options.push(this.agentmaster[i].vendor_id);
             
        //  }
         

          })
          .catch((ex) => {
            console.log('error', ex)
          })
        },
       //Vendor list
               /*******Function for Vendor List********/
      displayvendorlist: function(){
        // alert("In");
        // document.getElementById("overlay").style.display = "block";
        // var userdata = localStorage.getItem('userData')
        // var userInfo = JSON.parse(userdata)
        // var recarr=[];

        //   // recarr=this.selectedVendor;
        //   const Obj={
        //        //brand_id: 621,
        //        brand_id: userInfo[0].brand_assign,
        //       style_id: this.$route.params.id
        //   }
          // style_id->143
        //agentmaster
        // axios.post(`${CONSTANTS.API_URL}/getvendorlist`,Obj)
        //   .then((result) => {
        //     // document.getElementById("overlay").style.display = "none";
        //     // this.vendor_msg = result.body.returnmsg;
        //     // this.agentmaster = result.body.returnvalue;
        //     this.vendor_list = result.body.returnvalue;
        //     this.selected_vendor = this.vendor_list.returnvalue[0].vendor_name
        //      for(var i = 0; i < this.agentmaster.length; i++) {
        //       var vendoryagent2 = {
        //   id: this.agentmaster[i].vendor_id
        // }
        // this.vendor_options.push(this.agentmaster[i].vendor_id);
             
        //  }
         

        //   })
        //   .catch((ex) => {
        //     console.log('error', ex)
        //   })
    },
       //vendor list ends 

       //NavBar Fix Function

            scroll:function(){
      if( this.scrolled = window.scrollY > 0){
           var navbar = document.getElementById("navbardetails");
         var sticky = navbar.offsetTop;
         if (window.pageYOffset > sticky) {
           // alert("innn");
           navbar.classList.add("sticky")
         } else {
          // alert("out");
         navbar.classList.remove("sticky");
        }
      }
     
     
    },


       /****** Function to design details ********/
       getdesigndetail: function () {
            var userdata = localStorage.getItem('userData')
      var userInfo = JSON.parse(userdata)
      console.log("gggggggggggggggggggggggggggggg",userInfo[0].user_type);
      this.selected_usertype=userInfo[0].user_type;
           this.isBusy = true;
       
           const Obj = {
                style_id: this.$route.params.id,              
              }
           axios.post(`${CONSTANTS.API_URL}/getdesigndetail`,Obj)
           .then(response => {
            // document.getElementById("overlay").style.display = "none";
             this.result = response.data
             if (this.result.returnmsg === 'Successful') {
              
            this.style_details  = this.result.returnvalue[0];
            this.selected_brand_id = this.style_details.brand_id; 
            this.selected_buyer= this.style_details.full_name;
            this.selected_user_id=this.style_details.user_id;
            this.displayvendorlist(this.style_details.brand_id);             
             }else {
              this.style_details =[];
              this.totalRows=0;
                this.isBusy = !this.isBusy;
             }
   
   
           })
           .catch(e => {
             this.errors.push(e)
           })
   
   
       },


       /*******Function for Vendor List********/
    //   displayvendorlist: function(brand_id) {
    //     var userdata = localStorage.getItem('userData')
    //     var userInfo = JSON.parse(userdata)
    //       const Obj={
    //           style_id: this.$route.params.id
    //       }
    //     axios.post(`${CONSTANTS.API_URL}/getmessagevendorlist`,Obj)
    //       .then((result) => {
    //         this.vendor_list = result.body.returnvalue;
            

    //       })
    //       .catch((ex) => {
    //         console.log('error', ex)
    //       })
    // },

      myFunction: function() {
        var input, filter, div, ul, li, i, txtValue;
        input = document.getElementById("myInput");
        filter = input.value.toUpperCase();
        div = document.getElementById("contacts_body");
        ul = div.getElementsByTagName("ul");
        for (i = 0; i < ul.length; i++) {
          li = ul[i].getElementsByTagName("li")[0];
          if (li) {
            txtValue = li.textContent || li.innerText;
            if (txtValue.toUpperCase().indexOf(filter) > -1) {
              ul[i].style.display = "";
            } else {
              ul[i].style.display = "none";
            }
          }       
        }
      },
       onlineuserfun:function(){
        // alert("inn");
        var userlisting = document.getElementById("onlineuserdropdown");
        // onlineuserdropdown.style.display = "none";
  if (userlisting.style.display === "block") {
    onlineuserdropdown.style.display = "none";
  } else {
    userlisting.style.display = "block";
  }
       },

        // displayvendorname:function (value){
        //   // alert(value);
        //   this.selected_vendor_name=value;
        // },
        refreshmessage: function(){
       
          if(this.selected_vendor_name!=''){
            this.getvendormsg(this.selected_vendor_id,this.selected_vendor_name);
          }
        },

        getvendormsg: function (value, value_name) {
        // alert(value);
        // alert(value_name);
           var userlisting = document.getElementById("onlineuserdropdown");
  if (userlisting.style.display === "block") {
    onlineuserdropdown.style.display = "none";
  } else {
    userlisting.style.display = "none";
  }
           this.selected_vendor_name=value_name;
          this.selected_vendor_id = value;
          var userData = localStorage.getItem('userData');
          var userInfo = JSON.parse(userData)
 
          console.log("rrrrrrrrrrrrrrrrrrrrrrrrrrrr",userInfo)
            const Obj={
              vendor_id:this.selected_vendor_id,
              user_id: this.selected_user_id,
              style_id: this.$route.params.id,
              // vendor_id: this.selected_vendor,
              // user_id:userInfo[0].user_id,
              // user_id: 579,
              
              
              // style_id: this.$route.params.id,
            } 
            console.log("999999999999999999999999999",Obj)
            // this.isBusy = true;
            axios.post(`${CONSTANTS.API_URL}/getlistofmessage`,Obj)
            .then(response => {
              this.result = response.data
              if (this.result.returnmsg === 'Successful') {
                console.log("PPPPPPPPPPPPPPPPPPP",this.result.returnvalue)
                this.messagedata  = this.result.returnvalue[0];
                // this.selected_date= Object.keys(this.messagedata.message_json);
                console.log("ddddddddddddddddddddddddd",this.selected_date)
                // this.selected_vendor_name=this.result.returnvalue[0].vendor_name;
                // alert("In")
                console.log("Hiiiiiiiiii111111111111",this.messagedata);
                this.returnmsg_data = this.result.returnmsg;
                // alert(this.returnmsg_data);
                this.totalRows = this.result.returnvalue.length;

                // this.availablevendors();
                //this.messages.push(message);
                this.isBusy = !this.isBusy;

                // this.availablevendors();
                

            //     setTimeout(() => {
            //     message.uploaded = true
            // }, 2000)
                
              }else {

               this.returnmsg_data = this.result.returnmsg;
               this.totalRows= 0;
               this.availablevendors();
                this.isBusy = !this.isBusy;
              }


            })
            .catch(e => {
              this.errors.push(e)
            }) 
        },

        onMessageSubmit: function () {
          // alert("In");
            var userData = localStorage.getItem('userData');
             // console.log('jjj',userData);
          var userInfo = JSON.parse(userData)
          // alert("Inn");
            const Obj={
              vendor_id: this.selected_vendor_id,
              user_id: this.selected_user_id,
              style_id:this.$route.params.id,
              // user_id: 579,
              message: this.txtInput,
              message_by: 'Buyer',
              
            }
            console.log("HHHHHHHHHHHHHHHHHHHHHH",Obj)
            // return false;
            // this.isBusy = true;
            axios.post(`${CONSTANTS.API_URL}/addnewMessages`,Obj)
            .then(response => {
              this.result = response.data
              console.log("TTTTTTTTTTTTTTTTT888888888888",this.result);
              if (this.result.returnmsg === 'Successful') {
                this.getvendormsg(this.selected_vendor_id,this.selected_vendor_name)
                // this.updateddata  = this.result.returnvalue;
                
                // this.totalRows = this.result.returnvalue.length;
                this.txtInput ='';
                // this.selectedId=this.updateddata[0].vendor_id;
                // this.messagedisplay(this.selectedId);
                //this.messages.push(message);
                // this.getvendormsg(this.selected_vendor_id,this.selected_vendor_name)
                this.isBusy = !this.isBusy;
                

            //     setTimeout(() => {
            //     message.uploaded = true
            // }, 2000)
                
              }else {
               this.updateddata =[];
               this.totalRows=0;
                this.isBusy = !this.isBusy;
              }


            })
            .catch(e => {
              this.errors.push(e)
            }) 
        },
        

     }
   };
</script>
<style>
   .short-div {
   height:55px;
   }


.quote-dropdowns .dropdown--accepted {
    border-top: 1px solid var(--fill-green-dark);
}

.quote-dropdowns>.card {
    background-color: var(--fill-white);
}
.quote-dropdowns .dropdown__header.dropdown__header--accepted {
    border: 1px solid var(--fill-green-dark);
    border-top: none;
    background-color: #e8fff5;
}
.card .card__section {
    flex-grow: 1;
    box-shadow: inset 0 -1px 0 0 #e5e5e5;
    box-shadow: inset 0 -1px 0 0 var(--fill-grey-light3);
}
.quote-dropdowns .dropdown__header {
    align-items: center;
    justify-items: center;
    justify-content: center;
    cursor: pointer;
}
.quote-dropdowns .card__section {
    padding: 16px 32px;
}
.f-sz-l {
    font-size: 15px;
}
.flex-col {
    flex-direction: column;
}
.flex, .flex-col {
    display: flex;
}
.f-w-semi-bold {
    font-weight: 600;
}
.f-sz-sm {
    font-size: 12px;
}
.f-w-semi-bold {
    font-weight: 600;
}   

.card .card__section {
    flex-grow: 1;
    box-shadow: inset 0 -1px 0 0 #e5e5e5;
    box-shadow: inset 0 -1px 0 0 var(--fill-grey-light3);
}
.quote-dropdowns .card__section {
    padding: 16px 32px;
}

.input-grp {
    width: 100%;
    margin-bottom: 16px;
}
.input-grp {
    margin-bottom: 10px!important;
}

.input-grp label {
    margin-bottom: 6px;
    color: #333340;
}

input[type=number], input[type=password], input[type=tel], input[type=text] {
    padding: 13px 12px;
    border-radius: 2px;
    border: 1px solid #bfbfbf;
}
.input-grp input, .input-grp label, .input-grp select {
    display: block;
    width: 100%;
}

.input-grp select:disabled {
    background-color: #ebebe4;
}
.input-grp select {
    background: url(/static/media/ic-arrow-drop-down.1f6abe65.svg) no-repeat;
    background-position: right 8px top 6px;
    -moz-appearance: none;
    -webkit-appearance: none;
    appearance: none;
}

.quote-dropdowns .dropdown__header.dropdown__header--accepted {
    border: 1px solid var(--fill-green-dark);
    border-top: none;
    background-color: #e8fff5;
}

    .msg_background{
    padding: 0.2px;


    /**/
    /*border-radius: 10px;*/
  }
  .messagerecord{
    margin-top: 169px;
    margin-right: 200px;
    font-size:20px;
  }
    .msg_body{
      overflow-y: scroll;
      overflow-x: hidden;
     
    }
    #heading_data{
      /*border-radius: 15px 15px 0 0 !important;*/
      border-bottom: 2px solid white !important;
      height: 70px;
      background-color: #0099FF;
      width:260px;
     
    }
    .main_body1{
      width: 970px;
    }
   .msg-footer{
    border-radius: 0 0 15px 15px !important;
      border-top: 0 !important;
      background-color: #F5F5F5 !important;


  }
  msg-footer textarea{
    display:block;
    font-size: 14px;
     white-space:nowrap;
     
  -webkit-box-shadow: none;
  -moz-box-shadow: none;
  box-shadow: none;
  resize: none;
  }
    .container{
      align-content: center;
       margin: 0 auto;
  width: 1180px;
  
  border-radius: 5px;
    }
    .search{
      border-radius: 15px 0 0 15px !important;
      background-color: white !important;
      border:0 !important;
      color:white !important;
    }
    .search:focus{
         box-shadow:none !important;
          outline:0px !important;
    }
    /*.type_msg{
      background-color: white !important;
      border:0 !important;
      color:white !important;
      height: 60px !important;
      overflow-y: auto;
    }*/
      #type_msg:focus{
         box-shadow:none !important;
           outline:0px !important;
    }
    .send_btn{
      border:1 !important;
      border-color: #20a8d8;
      background-color: #4d94ff;
      cursor: pointer;
    }
    .search_btn{
      border-radius: #20a8d8 !important;
      border:0 !important;
      background-color: #20a8d8;
      cursor: pointer;
    }
    .contacts{
      list-style: none;
      
       padding: 20px;
      height: 770px;
    }
    .vendorhead{
      width:200%;
    }
    #headingdata{
       padding: 12px;
    border-bottom: 2px solid white;
    }
   .headervendorname{
    margin-top:10px;
    margin-left:-20px;
   }

    .contacts li{
      width: 100% !important;
      padding: 5px 10px;
      margin-bottom: 15px !important;
    }
    #select_user{
       font-size: 13px;
       align-items:center;
       transition: 0.3s;

    }
    #select_user:hover{
      color:#333;
      font-size:11px;
      align-items:center;
      background-color:#B0E0E6;
       width: 250px;
    
    }
    #select_user:active,
    #select_user:visited{
      background-color: #3498db !important;
    }
    .active{
       padding-bottom: 20px;

  }

 /* .active{
      background-color: white;

  }*/
   /* */
    /*#select_user:hover{
      text-decoration: none;
   color: #fff;
   border-radius: 20px;
   background-color: #cccccc;
    }*/
   /* #select_user:active{
      border-radius: 20px;
      background-color: #668cff;
      height: 60px
    }
    #select_user:visited{
      border-radius: 20px;
      background-color: #53c653;
    }*/
    .user_img1{
      height: 45px;
      width: 30px;
      border:1.5px solid #f5f6fa;
      margin-left: -20px;

    }
    .user_img{
      height: 45px;
      width: 30px;
      border:1.5px solid #f5f6fa;
      margin-left: 10px;

    }
    .user_img_msg{
      height: 30px;
      width: 30px;
      border:1.5px solid #f5f6fa;

    
    }
   /*.user_img_msg #vendor{
    float: inherit;
   }*/
  .img_cont{
      position: relative;
      height: 45px;
      width: 70px;

  }
  .img_cont_msg{
      height: 40px;
      width: 40px;
  }
  .text-span{
    background:blue;
    border-radius:50%;
    height: 26px;
    width: 26px;
    line-height: 26px;
    display: inline-block;
    text-align: center;
    margin-right: 6px;
}
.text-span2{
    background:gray;
    border-radius:50%;
    height: 26px;
    width: 26px;
    line-height: 26px;
    display: inline-block;
    text-align: center;
    margin-right: 6px;
}
/*.online_icon{
    position: absolute;
    height: 1px;
    width:1px;
    background-color: #4cd137;
    border-radius: 50%;
    bottom: 1em;
    right: 1em;
    border:1px solid white;
  }*/
  .online_icon{
     position: absolute;
    top: 28px;
    right: 26px;
     float:left;
    height: 10px;
    width:10px;
    /*right: 300px;*/
    background-color: #4cd137;
    border-radius: 50%;
    bottom: 3em;
    right: 2em;
    border:1.5px solid white;
   
  }
  .vendorname{
    margin-left: -10px;
  }
   .online_icon1{
        top: 32px;
    left: 17px;
    position: absolute;
    /*position: absolute;*/
    height: 10px;
    width:10px;
    /*right: 300px;*/
    background-color: #4cd137;
    border-radius: 50%;
    bottom: 3em;
    right: 2em;
    border:1.5px solid white;
  }
  .offline{
    background-color: #c23616 !important;
  }
  .user_info{
    margin-top: auto;
    margin-bottom: auto;
    font-size: 16px;
    position: relative;
    bottom: 11px;
    margin-left: 0px;
  }
  .main_body_icon{
    font-size: 16px;
    color: black;
    margin-left: 0px;
    position: relative;
  }

  .msg_cotainer{
    margin-top: auto;
    margin-bottom: auto;
    margin-left: 10px;
    border-radius: 25px;
    background-color: #82ccdd;
    padding: 10px;
    position: relative;
  }
  .msg_cotainer_send{
    margin-top: auto;
    margin-bottom: auto;
    margin-right: 10px;
    border-radius: 25px;
    background-color: #78e08f;
    padding: 10px;
    position: relative;
  }
  .line{
width: 112px;
height: 47px;
border-bottom: 1px solid black;
position: absolute;
}
  .msg_time{
    position: absolute;
    left: 0;
    bottom: -15px;
    color: rgba(255,255,255,0.5);
    font-size: 10px;
  }

  .brand-card{
   /*border-radius:0px !important;
   background: #444753;*/
  padding-left:35px;
  }

     .sidebar{
   background: #17a2b8!important;
   width:50px !important;
   }

   .sidebar .sidebar-nav{
    width:50px !important;
   }
   .sidebar .nav{
    width:50px !important;
   }

   .main{
    margin-left:50px !important;
   }
   #rec_msg{    
    margin-left: 40%;
    position: absolute;
   }


/*** Tabb ***/
.header-tabs__navbar {
    margin-top: auto;
    align-items: center;
    border-top: 1px solid var(--fill-grey-light2);
}
.flex {
    display: flex;
}

.header-tabs__tab {
    position: relative;
    flex: 1 1;
    height: 43px !important;
    padding: 12px 22px;
    border-bottom: 3px solid var(--fill-grey-light3);
    display: flex;
    flex-direction: row;
    cursor: pointer;
    border: 1px solid #63c2de;
    border-radius: 12px;
}

.header-tabs__tab-image {
    padding-right: 8px;
}

.header-tabs__tab-block {
    display: flex;
    flex-direction: column;
    justify-content: center;
}
 
.header-tabs__tab .sub_title {
    font-size: 12px;
    line-height: 16px;
    text-transform: capitalize;
    font-weight: 400;
    color: var(--fill-grey-medium);
} 



html, body {
  margin: 0
}
.wrapper {
  display: flex;
  flex-direction: column;
  height: 92vh;
  width: 100%;
  background-color:white
}


/*Todays CSS*/
.nav_row_tabs {
 
  display: flex;
 /* border-top: 1px solid #D7DBDD;
  border-bottom: 1px solid #D7DBDD;*/
}

  #activeTitle{
  font-size: 14px;
}

/*Message Box CSS*/
  .short-div {
  height:55px;
}
.card{
 border:0px !important; 
}
.record{
    text-align: center;
  }
  /*Style for Message*/
  /*.chat{
      margin-top: auto;
      margin-bottom: auto;
    }*/
    .chat{
  width: 620px;
  float:right;
  /*background: #F2F5F8;*/
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
      /*margin-right: 45px;*/
  color: #434651;
    }
    #chatbody{
      /*height: 380px !important;
      overflow-x:scroll;*/
      overflow-y: scroll;
      /*background-color: #F5F5F5;*/
      max-width:850px;
      height: 400px;
   overflow: auto;
   overflow-x: hidden;
   

      /*height: 80vh !important;
      overflow-wrap: break-word;
      overflow-y: scroll;
      background-color: #F5F5F5;
      white-space: nowrap;
      scroll-behavior: auto;
      display:flex;
     
       position: absolute;
  bottom: 0;
  right: 0;
  width: 300px;
  margin: 40px;
  margin-bottom: 0;
  font-size: 13px; */
    }
    #move{
      display: contents;
        text-align: justify;
        letter-spacing: 1px;
        word-spacing: 1px;
    }
    #chat{
      display: contents;
        text-align: justify;
        letter-spacing: 1px;
        word-spacing: 1px;
    }
    #contacts_body{
      height: 480px !important;
      padding:  0.75rem 0 !important;
      overflow-y: scroll;
      overflow-x:hidden;
      /*margin-right:10px;*/
     
      white-space: nowrap;
    width: 260px;
     
      background-color: #F5F5F5;  
    }
    .inputsearch{
      width: 100%;
      height: 25px;
    }
    .search{
      border-radius: 15px 0 0 15px !important;
      background-color: white !important;
      border:0 !important;
      color:white !important;
    }
    .search:focus{
         box-shadow:none !important;
          outline:0px !important;

    }
    /*.type_msg{
      background-color: white !important;
      border:0 !important;
      color:white !important;
      height: 60px !important;
      overflow-y: auto;
    }*/
      #type_msg:focus{
         box-shadow:none !important;
           outline:0px !important;

    }
    .send_btn{
      border:1 !important;
      border-color: #20a8d8;
      background-color: #4d94ff;
      cursor: pointer;

    }
    .search_btn{
      border-radius: #20a8d8 !important;
      border:0 !important;
      background-color: #20a8d8;
      cursor: pointer;
    }
    .contacts{
      list-style: none;
      padding: 0;
    }
    .contacts li{
      width: 100% !important;
      padding: 5px 10px;
      margin-bottom: 15px !important;
    }
 /* .active{
      background-color: white;

  }*/
   /* .chatbody{
      width: 60%;
      height: 800px;
    }*/

    .user_img{
      height: 40px;
      width: 30px;
      border:1.5px solid #f5f6fa;
    
    }
    .user_img_msg{
      
      height: 30px;
      width: 30px;
      border:1.5px solid #f5f6fa;
    
    }


.user_info {
    margin-top: auto;
    margin-bottom: auto;
    font-size: 16px;
    position: absolute;
    bottom: 11px;
    margin-left: 0px;
}
  .selected_user {
      margin-left: 11px;
       top: 22px; 
      /* margin-top: -21px; */
      margin-bottom: 60px;
  }
  .user_info span{
    font-size: 16px;
    color: black;
    margin-right: 190px;
  }
  .user_info p{
  font-size: 9px;
  color: black;
  }

  .msg_time{
    position: absolute;
    left: 0;
    bottom: -15px;
    color: rgba(255,255,255,0.5);
    font-size: 10px;
  }
  .main_body{
    flex: 0 0 66.66667%;
    max-width: 75%;
  }
  /*.mb-4, .my-4 {
    margin-bottom: 0.5rem !important;
    position: absolute;
    top: 65px;
  }*/
 /* #vendor_name{
    font-size: 16px;
    color: black;
    font-style: normal
  }*/
  .vendor_msg{
    
    /*border: 2px solid #e4e7e8;
    background-color: #E6E6FA;
    border-radius: 9px;
    padding: 5px;*/
    /*color: red;
    float: left;
    max-width:300px;*/
    /*align-self:flex-end;
    margin: 15px 15px 5px 15px;
    max-width: 450px;
    white-space: initial;*/
   float: left;
    border: 0px solid #aab4b7;
    background-color: #B0E0E6;
    border-radius: 9px;
    padding: 5px;
    margin: 15px 15px 5px 15px;
    margin-right:250px;
  }
  .admin_msg_time{

  }
  .msg_date{
     margin-left: 20px;
  }
  #adminmsgid{
   float: right !important;
   margin-left: 420px;
  }
  .admin_msg{
    margin-left:200px;
    /*float:right;*/
       /*border: 2px solid #e4e7e8;*/
    /*background-color: #E6E6FA;*/
    background-color: #F5F5F5;
    border-radius: 9px;
    padding: 5px;
    /*color: red;
    float: left;
    max-width:300px;*/
    align-self:flex-end;
    margin: 15px 15px 5px 15px;
    /*max-width: 300px;*/
    word-break: break-word;
    width: 300px !important;
    white-space: initial;



    /*margin-right: 590px !important;
    max-width:300px;*/
    
    
    
    /*border: 0px solid #aab4b7;
    background-color: #B0E0E6;
    border-radius: 9px;
    padding: 5px;
    margin: 15px 15px 5px 15px;*/
    
   
    /* 
    
  background: #683db8;
  color: #FFF;
  
  padding: 10px;
  margin-bottom: 4px;
  font-size: 13px;
    margin: auto;*/

  }
  .admin_msg_time{
    margin-left:200px !important;
    float: right !important; 
  }
.vendor_msg_class{
    /*margin-right: 327px !important;*/
    /*background-color: #F5F5F5;*/
    background-color: #B0E0E6;
    border-radius: 9px;
    padding: 5px;
    align-self:flex-end;
    margin: 15px 15px 5px 152px;
    /*max-width: 450px;*/
    max-width: 390px;
    white-space: initial;
}
.vendor_msg_time{
  margin-right: 327px !important;
  float: left !important;
}

  .msg_time_send{
    position: absolute;
    right:0;
    bottom: -15px;
    color: rgba(255,255,255,0.5);
    font-size: 10px;
  }
  .msg_head{
    position: relative;
  }
  /*@media(max-width: 576px){
  .contacts_card{
    margin-bottom: 15px !important;
  }
  }*/
  /*Style for Message end*/
/*Message Box CSS Ends*/

/*Added CSS*/
/*.requesticon{
   padding-top: 8px; 
   color: #24a0ed;
}*/
/*.requestvendor{
 width: 200px !important;
 height: 32px;
}*/

html, body {
  margin: 0
}
.wrapper {
  display: flex;
  flex-direction: column;
  height: 92vh;
  width: 100%;
  background-color:white
}
.header-tabs__tab {
    position: relative;
    flex: 1 1;
    height: 43px !important;
    padding: 12px 22px;
    border-bottom: 3px solid var(--fill-grey-light3);
    display: flex;
    flex-direction: row;
    cursor: pointer;
    border: 1px solid #63c2de;
    border-radius: 12px;
}



/*Todays CSS*/
.nav_row_tabs {
 
  display: flex;
  border-top: 1px solid #D7DBDD;
  border-bottom: 1px solid #D7DBDD;
}


  .nav_tabs__tab--disabled {
    cursor: not-allowed!important;
    opacity: .6;
    pointer-events: none; 
}

  /*CSS 2710*/
  .nav_tabs__tab--active:after {
    background: var(--fill-primary-blue);

}

  .nav_tabs__tab-image {
    padding-right: 8px;
}
.nav_tabs__tab-block {
    display: flex;

    flex-direction: column;
    justify-content: center;
}
.nav_tabs__tab-block {
    display: flex;
    flex-direction: column;
    justify-content: center;
}

.nav_tabs__navbar {
    margin-top: auto;
    align-items: center;
    border-top: 1px solid #D7DBDD;
}
#activeTitle{
  font-size: 14px;
}
.viewClass{
  width: 190px;
}
.swal2-header {
    display: flex;
    flex-direction: column;
    align-items: center;
    font-size: 10px;
}
.selectedcolor{
  padding:5px;
  text-align:center;
}
.overlay {
  height: 100%;
  width: 0;
  position: fixed;
  z-index: 1;
  top: 0;
  left: 0;
  background-color: rgb(255,255,255);
  /*background-color: rgb(119 119 119);*/
  background-color: rgba(255,255,255, 1);
  /*background-color: rgb(119 119 119,0.9);*/
  overflow-y: hidden;
  overflow:auto;
  transition: 0.5s;
}
.overlay .closebtn {
  position: absolute;
  top: 30px;
  right: 20px;
  font-size: 60px;
  color: #16A2D7;
}
.overlay-content {
  position: relative;
  top: 11%;
  right: 15px;
  width: 100%;
  text-align: center;
  margin-top: 30px;
  color:#bbbaba;
}
/*.overlay a {
  padding: 8px;
  text-decoration: none;
  font-size: 36px;
  color: #818181;
  display: block;
  transition: 0.3s;
}*/
.overlay a {
    padding: 0px;
    text-decoration: none;
    font-size: 18px;
    color: #16A2D7;
    display: block;

    transition: 0.3s;
}
.overlay a:hover, .overlay a:focus {
  color: #0864d6;
}
.design-list__item1 {
    height: 67px;
    padding: 12px 20px;
    padding-right: 6px;
    /*border-bottom: none !important;*/
    cursor: pointer;
}
.imgsidedesign{
  width: 20%; 
  height: 100%;
  border-radius: 48%;
  border:1px solid #e4e4e4;
}
 #navbardetails {
  overflow: hidden;
   background:#fff;
}
.sticky {
  position: fixed;
 z-index: 1;
  width: 80%;
}
.buyerdate{
 margin-left: 400px;
}
.refreshmsg{
  /*margin-left: 208px;*/
  display: flex;
  justify-content: center;
  margin-top: 10px;
  font-size: 20px; 
  color: #0000FF;
}

@media screen and (max-width: 1170px) {
  .side{
    display: none;
  }

}
@media screen and (min-width: 1170px) {
  .navbtn{
    display: none;
  }
 
}
@media screen and (min-width: 1170px) {
  .closebtn{
    display:none;
  }
 
}
@media screen and (min-width: 320px) {
  .overlay {
  height: 100%;
  width: 0;
  position: fixed;
  z-index: 1;
  top: 15px;
  left: 0;
  background-color: rgb(255,255,255);
  /*background-color: rgb(119 119 119);*/
  background-color: rgba(255,255,255, 1);
  /*background-color: rgb(119 119 119,0.9);*/
  overflow-y: hidden;
  overflow:auto;
  transition: 0.5s;
}
  .overlay .closebtn {
  position: absolute;
  top: 30px;
  right: 20px;
  font-size: 30px;
  color: #16A2D7;
}
.overlay a {
    padding: 0px;
    text-decoration: none;
    font-size: 9px;
    color: #16A2D7;
    display: block;

    transition: 0.3s;
}
.f-sz-sm{
  font-size:8px;

}
.design-list__subtitle1{
  margin-left: 25px;
  border-bottom: 1px solid #e4e4e4;
}
.design-list__item1 {
    height: 56px;
    padding: 10px 21px;
    padding-right: 6px;
    border-bottom: 1px solid #d4d4d4;
    cursor: pointer;
}

.imgsidedesign{
  width: 61%; 
  height: 100%;
  border-radius: 48%;
  border:1px solid #e4e4e4;
}
.design-list__title1{
  margin-left: 25px;
}
 
}
@media screen and (min-width: 411px and min-width: 414px) {
  .overlay {
  height: 100%;
  width: 0;
  position: fixed;
  z-index: 1;
  top: 15px;
  left: 0;
  background-color: rgb(255,255,255);
  
  background-color: rgba(255,255,255, 1);
  
  overflow-y: hidden;
  overflow:auto;
  transition: 0.5s;
}
  .overlay a {
    padding: 0px;
    text-decoration: none;
    font-size: 11px;
    color: #16A2D7;
    display: block;

    transition: 0.3s;
}
.design-list__subtitle1{
  border-bottom: 1px solid #e4e4e4;
}
.imgsidedesign{
  width: 61%; 
  height: 100%;
  border-radius: 48%;
  border:1px solid #e4e4e4;
}
 
}
 @media screen and (min-width: 1024px) {
  .overlay a {
    padding: 0px;
    text-decoration: none;
    font-size: 16px;
    color: #16A2D7;
    display: block;

    transition: 0.3s;
}
.overlay .closebtn {
  position: absolute;
  top: 30px;
  right: 20px;
  font-size: 45px;
  color: #16A2D7;
}
.design-list__title1{
  margin-left: 55px;
  margin-bottom: 2px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    max-width: 100%;
}
.design-list__subtitle1{
  
  border-bottom: 1px solid #e4e4e4;
}
.imgsidedesign{
  width: 20%; 
  height: 100%;
  border-radius: 48%;
  border:1px solid #e4e4e4;
}
 
}
@media screen and (min-width: 768px) {
  .overlay a {
    padding: 0px;
    text-decoration: none;
    font-size: 16px;
    color: #16A2D7;
    display: block;

    transition: 0.3s;
}
.overlay .closebtn {
  position: absolute;
  top: 30px;
  right: 20px;
  font-size: 45px;
  color: #16A2D7;
}
.design-list__title1{
  margin-left: 55px;
  margin-bottom: 2px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    max-width: 100%;
}
.design-list__subtitle1{
  
  border-bottom: 1px solid #e4e4e4;
}
.imgsidedesign{
  width: 30%; 
  height: 100%;
  border-radius: 48%;
  border:1px solid #e4e4e4;
}
 
}


.designtitle{
  margin-top:0.625em;
  margin-bottom:0.625em;
  width: 85%;
}
.dropdowndesign{
  float: right !important;
  margin-right: 0.625em !important;
}
.divdesign{
  float: left;
  border: 1px solid lightgray;
}
.imgdesign{
  padding:  0.3125em;
  height:13.75em;
  width: 21.8125em;
}
.btndesign{
  padding:0.3125em;
  margin-left: 30%;
}
.stylefield{
  font-size: 0.9375em !important;   
}
@media (min-width: 576px)
{
.navbar-expand-sm {
    flex-flow: row wrap;
    justify-content: flex-start;
}
}
@media (max-width: 320px)
{

  .designtitle{
    /* margin-top:10px;
  margin-bottom:10px;*/
  width: 80%;
  font-size:8px;
  padding: 5px;
  }
  .imgdesign{
    width: 90px;
    height: 80px;
  }
  .btndesign{
  padding:1px;
  font-size:9px;
  margin-top: 3px;
  margin-left:25px;
  
}
.divdesign{
  float: left;
  border: 1px solid lightgray;
  height: 110px;
  margin-top: -50px;
  margin-bottom: 10px;
}
.stylefield{
  font-size: 10px !important;   
}
  .coldesign{
    flex: 0 0 100% !important;
    max-width: 85% !important;
}
.detailsrow{
  display: flex;
    flex-wrap: wrap;
    margin-right: 0px;
    margin-left: 0px;
}
.selectedcolor{
  padding:5px;
  text-align:center;
  width:50%;
}

/*.colonb{
  text-align: center;
  position: absolute;
  
}
.titleb{
   position: absolute;
   width: 60%;
   
}*/
}
@media (max-width: 360px)
{
  .refreshmsg {
    margin-left: -50px !important;
}
  .designtitle{
    /* margin-top:10px;
  margin-bottom:10px;*/
  width: 90% !important;
  font-size:10px !important;
  padding: 5px !important;
  }
  .imgdesign{
    width: 90px !important;
    height: 80px !important;
  }
  .btndesign{
  padding:2px !important;
  font-size:9px !important;
  margin-top: 3px !important;
  margin-left:15px !important;
  
}
.divdesign{
  float: left !important;
  border: 1px solid lightgray !important;
  height: 110px !important;
  margin-top: -50px !important;
  margin-bottom: 5px !important;
  margin-left:1px !important;
}
.brandcard {
    padding-left: 12px !important;
}
.dropdowndesign{
  float: right !important;
  margin-right: 10px !important;
}
/*.stylefield{
  font-size: 11px !important;

    padding: 0px !important;
}*/
.coldesign{
    flex: 0 0 100% !important;
    max-width: 86% !important;
}
.stylefield{
  font-size: 9px !important;
    padding: 0px !important;
    margin-left: -17px !important;
}
.colonb{
  text-align: center !important;
  position: absolute !important;
  margin-left: 10px !important;
}
.titleb{
   position: absolute !important;
    margin-left: 50% !important;
}
/*#chatbody {
    width: 330px;
}
#chatbody {
     width: 330px;
}
.msg-footer{
   width: 330px;
}
#adminmsgid {
    float: right !important;
    margin-left: 220px;
}*/
#headingdata {
    width: 300px !important;
}
.msg-footer{
   width: 300px !important;
}

}
@media (max-width: 280px)
{
  .designtitle{
    /* margin-top:5px;
  margin-bottom:5px;*/
  width: 70% !important;
  font-size:9px !important;
  /*padding: 10px !important;*/
  }
  .imgdesign{
    width: 80px !important;
    height: 60px !important;
  }
  .btndesign{
  padding:3px !important;
  font-size:9px !important;
  margin-top: 5px !important;
  margin-left:9px !important;
  
}
/*.divdesign{
  float: left;
  border: 1px solid lightgray;
  height: 95px !important;
}*/
.divdesign{
  float: left !important;
  border: 1px solid lightgray !important;
  height: 95px !important;
  margin-top:-50px !important;
  margin-bottom:5px !important;
}
/*.brand-card {
    padding-left: 10px !important;
}*/
.dropdowndesign{
  /*float: right;*/
  margin-right: 10px !important;
  /*margin-bottom:10px;*/
}
.stylefield{
  font-size: 10px !important;
    padding: 0px !important;
}
.coldesign{
    flex: 0 0 104% !important;
    max-width: 105% !important;
}
.detailsrow{
  display: flex;
    flex-wrap: wrap;
    margin-right: 0px;
    margin-left: 0px;
}
.selectedcolor{
  padding:1px;
  text-align:center;
  width:50%;
}


}
@media (max-width: 450px) and (min-width: 350px) 
{
  .designtitle{
     /*margin-top:5px;
  margin-bottom:5px;*/
  width: 80% !important;
  font-size:10px !important;
  padding: 10px !important;
  }
  .imgdesign{
    width: 120px !important;
    height: 90px !important;
  }
  .btndesign{
  padding:4px !important;
  font-size:10px !important;
  margin-top: 5px !important;
  margin-left:25px !important;
  
}
.divdesign{
  float: left !important;
  border: 1px solid lightgray !important;
  height: 130px !important;
  margin-top:-50px !important;
  margin-bottom:10px !important;
}
.brandcard {
    padding-left: 15px !important;
}
.dropdowndesign{
  float: right !important;
  margin-right: -34px !important;
  margin-bottom:10px !important;
}
.stylefield{
  font-size: 10px !important;
    padding: 0px !important;
    margin-left: -16px !important;
}
/*.coldesign{
    flex: 0 0 50% !important;
    max-width: 100% !important;
}*/
.coldesign{
    flex: 0 0 100% !important;
    max-width: 85% !important;
}
/*.stylefield{
  font-size: 9px !important;
    padding: 0px !important;
    margin-left: -17px !important;
}*/
.colonb{
  text-align: center !important;
  position: absolute !important;
  margin-left: 10px !important;
}
.titleb{
   position: absolute !important;
    margin-left: 50% !important;
}
.detailsrow{
  display: flex;
    flex-wrap: wrap;
    margin-right: 0px;
    margin-left: 0px;
}
.selectedcolor{
  padding:5px;
  text-align:center;
  width:50%;
}



}
@media (max-width: 540px) and (min-width: 450px)
{
  .designtitle{
     /*margin-top:5px;
  margin-bottom:5px;*/
  width: 80% !important;
  font-size:13px !important;
  padding: 10px !important;
  }
  .imgdesign{
    width: 150px !important;
    height: 120px !important;
  }
  .btndesign{
  padding:4px !important;
  font-size:10px !important;
  margin-top: 5px !important;
  margin-left:35px !important;
  
}
.divdesign{
  float: left !important;
  border: 1px solid lightgray !important;
  height: 160px !important;
  margin-top:-50px !important;
  margin-bottom:10px !important;
}
/*.brandcard {
    padding-left: 15px !important;
}*/
.detailsrow{
  display: flex;
    flex-wrap: wrap;
    margin-right: 0px;
    margin-left: 0px;
}
.dropdowndesign{
  float: right !important;
  margin-right: -10px !important;
  margin-bottom:5px !important;
}
.stylefield{
  font-size: 13px !important;
    padding: 0px !important;
    margin-left: -16px !important;
}
/*.coldesign{
    flex: 0 0 50% !important;
    max-width: 100% !important;
}*/
.coldesign{
    flex: 0 0 100% !important;
    max-width: 85% !important;
}
/*.stylefield{
  font-size: 9px !important;
    padding: 0px !important;
    margin-left: -17px !important;
}*/
.colonb{
  text-align: center !important;
  position: absolute !important;
  margin-left: 10px !important;
}
.titleb{
   position: absolute !important;
    margin-left: 50% !important;
}

.selectedcolor{
  padding:5px;
  text-align:center;
  width:50%;
}

}
/*@media (max-width: 360px)
{
  
}*/
@media (max-width: 768px)and (min-width:550px) 
{
  .designtitle{
  /*   margin-top:5px !important;
  margin-bottom:5px !important;*/
  width: 80% !important;
  font-size:17px !important;
  padding: 10px !important;
  }
  .imgdesign{
    width: 220px !important;
    height: 150px !important;
  }
  .btndesign{
  padding:4px !important;
  font-size:10px !important;
  margin-top: 5px !important;
  margin-left:70px !important;
  
}
.divdesign{
  float: left !important;
  border: 1px solid lightgray !important;
  height: 190px !important;
  margin-top:-40px !important;
  margin-bottom: 10px !important;
  margin-left: 40px !important;
}
/*.brand-card {
    padding-left: 15px !important;
}*/
.dropdowndesign{
  float: right;
  margin-right: 5px !important;
  /*margin-bottom:10px !important;*/
}
.stylefield{
  font-size: 15px !important;
    padding: 0px !important;
    margin-left: 30px !important;
}
.coldesign{
    flex: 0 0 85% !important;
    max-width: 100% !important;
}
  #adminmsgid{
   float: right !important;
   margin-left: 300px;
  }
  .vendor_msg_class{
    /*margin-right: 327px !important;*/
    /*background-color: #F5F5F5;*/
    background-color: #B0E0E6;
    border-radius: 9px;
    padding: 5px;
    align-self:flex-end;
    margin: 15px 15px 5px 152px;
    /*max-width: 450px;*/
    max-width: 320px;
    white-space: initial;
}
.buyerdate{
 margin-left: 345px;
}

}
@media (max-width: 700px)
{
  .designtable{
    display:none;
  }
}

@media (min-width: 700px)
{
  .tablebtn{
    display:none;
  }
}
@media (max-width: 375px) and (min-width:350px) 
{
  .tdhead{
   font-size:8px;
  }
  .tdsize{
    font-size:8px
  }
  .tdunit{
    font-size: 12px;
    width: 35px;
    padding: 2px;
  }
  .tdageform{
    padding: 2px;
    font-size: 13px;
    width: 40px;
  }
  .tdageto{
    padding: 2px;
    width: 40px;
    font-size: 13px;
  }
  .tdfactory{
    padding: 7px !important;
    font-size: 12px !important;
    width: 35px !important;
    height: 23px !important;
  }
 .tdquantity{
    padding: 7px !important;
    font-size: 12px !important;
    width: 36px !important;
    height: 23px !important;
 }
 .tabset{
  margin-left:-13px;
 
  
 }
}
@media (max-width: 320px)
{
 .tabset{
  margin-left:-9px;
  overflow:auto;
  
 }
}
@media (max-width: 300px)
{
 .tabset{
  margin-left:-9px;
  overflow:auto;
 }
}
@media (max-width: 450px)
{
 .tdhead{
  font-size:10px !important;
 }
 .tdsize{
    font-size:10px !important;
  }
  .tdunit{
    padding: 3px !important;
    font-size: 15px !important;
    width: 40px !important;
     height: 27px !important;
  }
  .tdageform{
    padding: 2px !important;
    font-size: 13px !important;
    width: 42px !important;
     height: 27px !important;
  }
  .tdageto{
   padding: 2px !important;
    font-size: 13px !important;
    width: 42px !important;
     height: 27px !important;
  }
  .tdfactory{
    padding: 2px !important;
    width: 42px !important;
    height: 27px !important;
    font-size: 12px !important;
  }
 .tdquantity{
     padding: 2px !important;
    width: 42px !important;
    height: 27px !important;
    font-size: 12px !important;
 }

}
@media (max-width: 540px) and (min-width:500px) 
{
  .tdunit{
    padding: 5px !important;
    font-size: 15px !important;
    width: 45px !important;
     height: 32px !important;
  }
  .tdageform{
   padding: 1px !important;
    width: 40px !important;
    height: 32px !important;
    font-size: 13px !important;
  }
  .tdageto{
   padding: 1px !important;
    width: 40px !important;
    height: 32px !important;
    font-size: 13px !important;
  }
   #adminmsgid{
   float: right !important;
   margin-left: 270px;
  }
  .vendor_msg_class{
    /*margin-right: 327px !important;*/
    /*background-color: #F5F5F5;*/
    background-color: #B0E0E6;
    border-radius: 9px;
    padding: 5px;
    align-self:flex-end;
    margin: 15px 15px 5px 152px;
    /*max-width: 450px;*/
    max-width: 320px;
    white-space: initial;
}
.buyerdate {
    margin-left: 340px;
}
  /*.tdfactory{
    padding: 2px !important;
    width: 42px !important;
    height: 27px !important;
    font-size: 12px !important;
  }
 .tdquantity{
     padding: 2px !important;
    width: 42px !important;
    height: 27px !important;
    font-size: 12px !important;
 }*/
}
/*Messaging Responsive Design*/
@media (min-width: 768px)
{
 #onlineuserdropdown{
  display:block !important;
 }
}
@media (max-width: 1040px)
{
 .detailside{
  display:none;
 }
 #contacts_body{
      height: 480px !important;
      padding:  0.75rem 0 !important;
      overflow-y: scroll;
      overflow-x:hidden;
      /*margin-right:10px;*/
     
      white-space: nowrap;
    width: 250px;
     
      /*background-color: #F5F5F5;  */
    }
  #heading_data{
      /*border-radius: 15px 15px 0 0 !important;*/
      border-bottom: 2px solid white !important;
      height: 70px;
      background-color: #0099FF;
      width:250px;
     
    }
     .user_img1{
      height: 30px;
      width: 25px;
      border:1.5px solid #f5f6fa;
      margin-left: -20px;

    }
    .online_icon1{
        top: 19px;
    left: 14px;
    position: absolute;
    /*position: absolute;*/
    height: 10px;
    width:10px;
    /*right: 300px;*/
    background-color: #4cd137;
    border-radius: 50%;
    bottom: 3em;
    right: 2em;
    border:1.5px solid white;
  }
}
@media (max-width: 768px)
{

     .chat{
  width: 490px;
  float:right;
  background: #F2F5F8;
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
      /*margin-right: 45px;*/
  color: #434651;
    }
 #contacts_body{
      height: 480px !important;
      padding:  0.75rem 0 !important;
      overflow-y: scroll;
      overflow-x:hidden;
      /*margin-right:10px;*/
     
      white-space: nowrap;
    width: 225px;
     
      background-color: #F5F5F5;  
    }
  #heading_data{
      /*border-radius: 15px 15px 0 0 !important;*/
      border-bottom: 2px solid white !important;
      height: 70px;
      background-color: #0099FF;
      width:225px;
     
    }
    .user_img1{
      height: 30px;
      width: 25px;
      border:1.5px solid #f5f6fa;
      margin-left: -20px;

    }
    .online_icon1{
        top: 19px;
    left: 14px;
    position: absolute;
    /*position: absolute;*/
    height: 10px;
    width:10px;
    /*right: 300px;*/
    background-color: #4cd137;
    border-radius: 50%;
    bottom: 3em;
    right: 2em;
    border:1.5px solid white;
  }
  .messagerecord{
      padding-left: 180px;
    padding-top: 200px;
    font-size:20px;
  }
  .vendorname{
    margin-left: -18px;
    font-size: 12px;
  }
   #select_user:hover{
      color:#333;
      font-size:10px;
      align-items:center;
      background-color:#B0E0E6;
       width: 200px;
    
    }
     #select_user:active,
    #select_user:visited{
      background-color: #3498db !important;
    }
    .active{
       padding-bottom: 20px;
  }
}
@media (min-width: 768px)
{
  #onlineuserdropdown{
  display:none;
 }
 .userbtn{
   display:none;
 }
}
@media (max-width: 540px)
{
  .refreshmsg{
  margin-left: -110px;
  display: flex;
  justify-content: end;
  margin-top: 10px;
  font-size: 20px; 
  color: #0000FF;
}
.online_icon {
    position: absolute;
    top: 28px;
    right: 26px;
    float: left;
    height: 10px;
    width: 10px;
    /* right: 300px; */
    background-color: #4cd137;
    border-radius: 50%;
    bottom: 3em;
    right: 0em;
    border: 1.5px solid white;
}
.headervendorname {
    margin-top: 10px;
    margin-left: 0px;
}
    .onlineuser{
  display:none;
 }
 #contacts_body{
      height: 400px !important;
      padding:  0.75rem 0 !important;
      overflow-y: scroll;
      overflow-x:hidden;
      /*margin-right:10px;*/
     border-bottom: 2px solid grey;
      white-space: nowrap;
    width: 465px;
     
      /*background-color: #F5F5F5;  */
    }
  #heading_data{
      /*border-radius: 15px 15px 0 0 !important;*/
      border-bottom: 2px solid white !important;
      height: 70px;
      background-color: #0099FF;
      width:465px;
     
    }
    .chat{
      margin-top: 10px;
  width: 465px;
  float:left;
  background: #F2F5F8;
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
      /*margin-right: 45px;*/
  color: #434651;
    }
    .vendorname{
    margin-left: -10px;
    font-size: 16px;
  }
  .online_icon1{
        top: 32px;
    left: 17px;
    position: absolute;
    /*position: absolute;*/
    height: 10px;
    width:10px;
    /*right: 300px;*/
    background-color: #4cd137;
    border-radius: 50%;
    bottom: 3em;
    right: 2em;
    border:1.5px solid white;
  }
  .user_img1{
      height: 45px;
      width: 30px;
      border:1.5px solid #f5f6fa;
      margin-left: -20px;

    }
      #select_user:hover{
      color:#333;
      font-size:12px;
      align-items:center;
      background-color:#B0E0E6;
       width: 465px;
    
    }
     #select_user:active,
    #select_user:visited{
      background-color: #3498db !important;
    }
    .active{
       padding-bottom: 20px;
  }
  #onlineuserdropdown{
 position: absolute;
 z-index: 1;
 }
}
@media (max-width: 414px)
{
   .refreshmsg{
  margin-left: -100px;
  display: flex;
  justify-content: end;
  margin-top: 10px;
  font-size: 20px; 
  color: #0000FF;
}
/*.online_icon {
    position: absolute;
    top: 28px;
    right: 26px;
    float: left;
    height: 10px;
    width: 10px;
     right: 300px; 
    background-color: #4cd137;
    border-radius: 50%;
    bottom: 3em;
    right: 0.7em;
    border: 1.5px solid white;
}*/
.headervendorname {
    margin-top: 10px;
    margin-left: 0px;
}
 #contacts_body{
      height: 400px !important;
      padding:  0.75rem 0 !important;
      overflow-y: scroll;
      overflow-x:hidden;
      /*margin-right:10px;*/
     border-bottom: 2px solid grey;
      white-space: nowrap;
    width: 330px;
     
      /*background-color: #F5F5F5;  */
    }
  #heading_data{
      /*border-radius: 15px 15px 0 0 !important;*/
      border-bottom: 2px solid white !important;
      height: 70px;
      background-color: #0099FF;
      width:330px;
     
    }
    .chat{
      margin-top: 10px;
  width: 330px;
  float:left;
  background: #F2F5F8;
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
      /*margin-right: 45px;*/
  color: #434651;
    }
    .vendorname{
    margin-left: -16px;
    font-size: 14px;
  }
  .online_icon1{
        top: 32px;
    left: 17px;
    position: absolute;
    /*position: absolute;*/
    height: 10px;
    width:10px;
    /*right: 300px;*/
    background-color: #4cd137;
    border-radius: 50%;
    bottom: 3em;
    right: 0.6em;
    border:1.5px solid white;
  }
  .user_img1{
      height: 45px;
      width: 30px;
      border:1.5px solid #f5f6fa;
      margin-left: -20px;

    }
      #select_user:hover{
      color:#333;
      font-size:12px;
      align-items:center;
      background-color:#B0E0E6;
       width: 330px;
    
    }
     #select_user:active,
    #select_user:visited{
      background-color: #3498db !important;
    }
    .active{
       padding-bottom: 20px;
  }
  /*.headervendorname{
    margin-top:10px;
    margin-left:-20px;
    width: 50%;
   }*/
   .messagerecord{
      padding-left: 95px;
    padding-top: 200px;
    font-size:16px;
  }
   #onlineuserdropdown{
 position: absolute;
 z-index: 1;
 }
 #adminmsgid {
    float: right !important;
    margin-left: 240px;
}
.admin_msg {
    margin-left: 200px;
   
    background-color: #F5F5F5;
    border-radius: 9px;
    padding: 5px;
    align-self: flex-end;
    margin: 15px 15px 5px 15px;
    font-size: 10px;
    word-break: break-word;
    width: 220px !important;
    white-space: initial;
}
  .vendor_msg_class{
    /*margin-right: 327px !important;*/
    /*background-color: #F5F5F5;*/
    background-color: #B0E0E6;
    border-radius: 9px;
    padding: 5px;
    align-self:flex-end;
    margin: 15px 15px 5px 152px;
    /*max-width: 450px;*/
    font-size: 10px;
    max-width: 220px;
    white-space: initial;
}
.buyerdate {
    margin-left: 285px;
}
#chatbody{
  width: 350px;
}
#headingdata{
  width: 350px;
}
.msg-footer{
 width: 350px;
}
}

@media (max-width: 375px) and(min-width: 365px)
{
 #contacts_body{
      height: 400px !important;
      padding:  0.75rem 0 !important;
      overflow-y: scroll;
      overflow-x:hidden;
      /*margin-right:10px;*/
     border-bottom: 2px solid grey;
      white-space: nowrap;
    width: 300px;
     
      background-color: #F5F5F5;  
    }
  #heading_data{
      /*border-radius: 15px 15px 0 0 !important;*/
      border-bottom: 2px solid white !important;
      height: 70px;
      background-color: #0099FF;
      width:300px;
     
    }
    .chat{
      margin-top: 10px;
  width: 300px;
  float:left;
  background: #F2F5F8;
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
      /*margin-right: 45px;*/
  color: #434651;
  
    }
    .vendorname{
    margin-left: -16px;
    font-size: 12px;
  }
  .online_icon1{
        top: 32px;
    left: 17px;
    position: absolute;
    /*position: absolute;*/
    height: 10px;
    width:10px;
    /*right: 300px;*/
    background-color: #4cd137;
    border-radius: 50%;
    bottom: 3em;
    right: 2em;
    border:1.5px solid white;
  }
  .user_img1{
      height: 45px;
      width: 30px;
      border:1.5px solid #f5f6fa;
      margin-left: -20px;

    }
      #select_user:hover{
      color:#333;
      font-size:10px;
      align-items:center;
      background-color:#B0E0E6;
       width: 300px;
    
    }
     #select_user:active,
    #select_user:visited{
      background-color: #3498db !important;
    }
    .active{
       padding-bottom: 20px;
  }
  .headervendorname{
    margin-top:10px;
    margin-left:-20px;
     font-size: 12px;
    width: 50%;
   }
   .messagerecord{
      padding-left: 95px;
    padding-top: 200px;
    font-size:16px;
  }
  #onlineuserdropdown{
 position: absolute;
 z-index: 1;
 }
  #adminmsgid {
    float: right !important;
    margin-left: 260px;
}
.admin_msg {
    margin-left: 200px;
   
    background-color: #F5F5F5;
    border-radius: 9px;
    padding: 5px;
    align-self: flex-end;
    margin: 15px 15px 5px 15px;
    font-size: 10px;
    word-break: break-word;
    width: 220px !important;
    white-space: initial;
}
  .vendor_msg_class{
    /*margin-right: 327px !important;*/
    /*background-color: #F5F5F5;*/
    background-color: #B0E0E6;
    border-radius: 9px;
    padding: 5px;
    align-self:flex-end;
    margin: 15px 15px 5px 152px;
    /*max-width: 450px;*/
    font-size: 10px;
    max-width: 220px;
    white-space: initial;
}
.buyerdate {
    margin-left: 285px;
}
#chatbody{
  width: 379px;
}
#headingdata{
  width: 379px;
}
.msg-footer{
 width: 379px;
}
}
@media (max-width: 320px)
{
  .refreshmsg{
   margin-left: 30px !important;
  }
  #chatbody{
  width:300px;
}
#headingdata {
    width: 280px !important;
}
.msg-footer {
    width: 280px !important;
}
#adminmsgid {
    float: right !important;
    margin-left: 190px;
}
.buyerdate {
    margin-left: 255px;
}
 #contacts_body{
      height: 400px !important;
      padding:  0.75rem 0 !important;
      overflow-y: scroll;
      overflow-x:hidden;
      /*margin-right:10px;*/
     border-bottom: 2px solid grey;
      white-space: nowrap;
    width: 250px;
     
      background-color: #F5F5F5;  
    }
  #heading_data{
      /*border-radius: 15px 15px 0 0 !important;*/
      border-bottom: 2px solid white !important;
      height: 70px;
      background-color: #0099FF;
      width:250px;
     
    }
    .chat{
      margin-top: 10px;
  width: 250px;
  float:left;
  background: #F2F5F8;
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
      /*margin-right: 45px;*/
  color: #434651;
    }
    .vendorname{
    margin-left: -16px;
    font-size: 10px;
  }
  .online_icon1{
        top: 32px;
    left: 17px;
    position: absolute;
    /*position: absolute;*/
    height: 10px;
    width:10px;
    /*right: 300px;*/
    background-color: #4cd137;
    border-radius: 50%;
    bottom: 3em;
    right: 0.4em !important;
    border:1.5px solid white;
  }
  .user_img1{
      height: 45px;
      width: 30px;
      border:1.5px solid #f5f6fa;
      margin-left: -20px;

    }
      #select_user:hover{
      color:#333;
      font-size:10px;
      align-items:center;
      background-color:#B0E0E6;
       width: 250px;
    
    }
     #select_user:active,
    #select_user:visited{
      background-color: #3498db !important;
    }
    .active{
       padding-bottom: 20px;
  }
  .headervendorname{
    margin-top:10px;
    margin-left:0px;
    font-size: 10px;
    width: 50%;
   }
   .messagerecord{
      padding-left: 70px;
    padding-top: 200px;
    font-size:16px;
  }
   #onlineuserdropdown{
 position: absolute;
 z-index: 1;
 }
}
.tr_class{
  background-color: white !important;
}
@media (min-width: 1140px)
{
  .navbardesignsm{
    display:none;
  }

}
@media (max-width: 1024px)
{
  .navbardesign{
    display:none;
  }

}
/*Added CSS Ends*/


</style>
